export default __webpack_public_path__ + "static/meprotejoilustracion-da791dad9e02aff559ad103e3a7a1dc6.svg";